import "./App.css";
import { Allroutes } from "./pages/Allroutes";
function App() {
  return (
    <div className="App">
      <Allroutes />
      {/* <ProductAdminList /> */}
    </div>
  );
}

export default App;
